import { Text, VStack, Link } from '@chakra-ui/react'

const MonthlyCourseUnregisterComplete = () => {
  return (
    <VStack minH="50vh" spacing={4} py={8} justifyContent="space-between">
      <VStack spacing={6} w="full">
        <Text fontSize="2xl" fontWeight="semibold">
          月額解除ページ
        </Text>
        <Text fontSize="xs">
          月額コースの解除が完了しました。
          <br />
          ご利用ありがとうございました。
        </Text>
      </VStack>
      <Link href="/" fontSize="xs">
        トップに戻る
      </Link>
    </VStack>
  )
}

export default MonthlyCourseUnregisterComplete
